<template>
  <div>
    <div class="text-xs uppercase tracking-wide text-gray-500 dark:text-gray-400">{{ label }}</div>
    <div class="mt-0.5 text-gray-900 dark:text-gray-100">{{ displayValue }}</div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
const props = defineProps({
  label: { type: String, required: true },
  value: { default: null },
});
const displayValue = computed(() => {
  const v = props.value;
  if (v === null || v === undefined || v === '') return '—';
  return v;
});
</script>
